// JavaScript Document
$(function () {
	/*
======================
BODY FADE IN
======================
*/

	setTimeout(function () {
		$("body").removeClass("fade-out");
	}, 320);

	setTimeout(function () {
		$("body").addClass("loaded");
		$("#page-loader").fadeOut(900);
		$(".page-wrap").removeClass("fade-out");
	}, 1200);

	/*
===============================
ADDITIONAL BODYCLASSES
===============================
*/

	if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1) {
		$("html").addClass("safari");
	}

	/*
================================
SCROLL ANIMATIONS (WOW JS)
================================
*/

	var wow = new WOW({
		boxClass: "wow",
		animateClass: "animated",
		offset: 0,
		mobile: true,
		live: true,
		scrollContainer: null,
		resetAnimation: false,
	});
	wow.init();

	/*
=========================
OBJECT FIT
=========================
*/

	$(function () {
		objectFitImages("img.object-fit");
	});

	/*
=====================
TEL LINKS
=====================
*/

	//Disable on desktop (non touch)...
	$(".no-touch a.tel").on("click", function (e) {
		e.preventDefault();
	});

	/*
=====================
TABLE WRAPPER
=====================
*/

	$("table").wrap('<div class="table-wrap"></div>');

	/*
======================
IFRAME WRAPPER
======================
*/

	$(".page-section iframe").wrap('<div class="iframe-wrap"></div>');

	/*
===============================
FIXED HEADER
===============================
*/

	//add header class
	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 1) {
			$("#masthead").addClass("scrolled");
		} else {
			$("#masthead").removeClass("scrolled");
		}
	});

	//check page position and add class if not at the top of page on load
	var pagePostion = $(window).scrollTop();

	if (pagePostion > 1) {
		$("#masthead").addClass("scrolled");
	} else {
		$("#masthead").removeClass("scrolled");
	}

	/*
======================
HAMBURGER MENU
======================
*/

	//open menu
	$(".menu-toggle").on("click", function () {
		$("body").toggleClass("mobile-navigation--open");
		$(this).toggleClass("active");
		$(".mobile-navigation").toggleClass("active");
	});

	//dash menu
	$("#dashboard-menu li.menu-item-has-children").append('<div class="menu-expand"><i class="fa-sharp fa-solid fa-chevron-down"></i></div>');
	//mobile menu
	$(".mobile-navigation ul li.menu-item-has-children").append('<div class="menu-expand"><i class="fa-sharp fa-solid fa-chevron-down"></i></div>');

	$(".menu-expand").on("click", function () {
		$(this).toggleClass("active");
		$(this).parent("li").toggleClass("active");
		$(this).parent("li").toggleClass("sub-menu-open");
		$(this).parent("li").find("> ul.sub-menu").slideToggle(600);
	});

	//hover class
	$("#dashboard-menu ul li")
		.on("mouseenter", function () {
			$(this).addClass("active-hover");
		})
		.on("mouseleave", function () {
			$(this).removeClass("active-hover");
		});

	$(".main-menu .close").on("click", function () {
		$(".hamburger").removeClass("active");
		$(".main-menu").removeClass("active");
	});

	/*
======================================
SMOOTH SCROLL
======================================
*/

	// SMOOTH SCROLLING FROM ANOTHER PAGE TO CORRECT ID
	//START AT TOP OF PAGE AND SCROLL DOWN ALWAYS
	if (window.location.hash) {
		setTimeout(function () {
			$("html, body").scrollTop(0).show();
			$("html, body").animate(
				{
					scrollTop: $(window.location.hash).offset().top - 0,
				},
				1000
			);
		}, 0);
	} else {
		$("html, body").show();
	}

	/*
=================================
FANCYBOX
=================================
*/

	/*$("[data-fancybox]").fancybox({
		// Custom Fancybox options can go here
		afterLoad: function (instance, current) {
			console.log("Fancybox has been loaded");
		},
		afterShow: function (instance, current) {
			console.log("Fancybox is visible");
		},
	});*/

	/*
=========================
ACCORDION
=========================
*/

	$(".accordion-item .toggle-header").on("click", function () {
		$(this).parent(".accordion-item").toggleClass("active");
		$(this).next(".toggle-content").slideToggle("slow");
	});

	/*
==========================
BUTTONS
==========================
*/

	if ($("p .button").length > 0) {
		$("p").each(function () {
			if ($(this).find(".button").length === 2) {
				$(this).addClass("two-buttons");
			}
		});
	}

	/*
==============================
DISABLE COMPANY NAME
==============================
*/

	$(".gfield.disabled input, .gfield.disabled select, .gfield.disabled textarea").each(function () {
		if ($(this).val() !== "") {
			// Add the disabled property and the 'disabled' class if there's a value
			$(this).prop("disabled", true);
			$(this).addClass("disabled");
		} else {
			// Remove the disabled property and the 'disabled' class if there's no value
			$(this).prop("disabled", false);
			$(this).removeClass("disabled");
		}
	});

	// Check if 'invitation=true' is present in the URL /
	var urlParams = new URLSearchParams(window.location.search);
	var companyfieldValue = $("#gform_3 #input_3_8").val(); // Get the value of the field

	if (urlParams.has("invitation") && urlParams.get("invitation") === "true" && companyfieldValue !== "") {
		// Disable the field with ID 'input_3_8' if it has a value and the URL has 'invitation=true'
		$("#gform_3 #input_3_8").prop("readonly", true);
		$("#gform_3 #input_3_8").addClass("disabled");
	}

		/*
	=======================================
	POPULATE COMPANY FIELD (REGISTRATION)
	=======================================
	*/

	function populateCompanyField() {
		// Get the current URL
		var url = window.location.href;

		// Use URLSearchParams to extract the 'company' parameter from the query string
		var urlParams = new URLSearchParams(window.location.search);
		var companyName = urlParams.get('company');
		if (companyName) {
			// Replace the '+' with space and set the value in the input field
			companyName = companyName.replace(/\+/g, ' ');
			$('#gform_3 #input_3_8').val(companyName);
			$('#gform_3 #input_3_8').addClass('has-value');
			$('#gform_3 #input_3_8').trigger('input').trigger('change');
		}
	}
	populateCompanyField();

	/*
=========================
hide duplicate
=========================
*/

	function hideDuplicatePendingUsersText() {
		// Find all <p> elements inside the parent with the ID 'pending-companies-users'
		var paragraphs = $("#pending-companies-users p");

		// Check if there are duplicate <p> elements with the same text
		paragraphs.each(function (index) {
			// If it's the second occurrence, hide it
			if ($(this).text() === "No pending users for new companies." && index !== 0) {
				$(this).hide();
			}
		});
	}
	hideDuplicatePendingUsersText();

	/*
=============================
COMPANY NAME - MY PROFILE
=============================
*/

	/*function ensureFieldValueVisible(fieldSelector) {
		// Select the field using the provided selector
		var $field = $(fieldSelector);

		if ($field.length) {
			// Get the value from the 'value' attribute
			var fieldValue = $field.attr("value");

			// Set the value to the input field to ensure it's displayed
			$field.val(fieldValue);
		}
	}
	ensureFieldValueVisible("#input_6_6");

	setTimeout(function () {
		ensureFieldValueVisible("#input_6_6");
	}, 500);*/

	/*
=============================
REPORT INSTRUMENT STOLEN FORM
=============================
*/

	function updateHiddenFields() {
		var selectedOption = $('#gform_8 select[name="input_9"]').find("option:selected");
		var instrumentName = selectedOption.data("instrument-name") || "";
		var serialNumber = selectedOption.data("serial-number") || "";

		// Update hidden fields
		$('#gform_8 input[name="input_6"]').val(instrumentName);
		$('#gform_8 input[name="input_8"]').val(serialNumber);
	}

	// Trigger update on page load for the default selected option
	updateHiddenFields();

	// Trigger update on change of the select option
	$('#gform_8 select[name="input_9"]').on("change", function () {
		updateHiddenFields();
	});

	/*
============================
CALENDAR
============================
*/

	const today = new Date();
	const currentYear = today.getFullYear();
	const currentMonth = today.getMonth(); // getMonth() returns 0-11 for Jan-Dec
	const currentDate = today.getDate();

	// Set minDate based on whether it's the current month or not
	let minDate;
	if (currentMonth === 0) {
		minDate = new Date(currentYear, 0, 1); // January 1st of the current year
	} else {
		minDate = new Date(currentYear, currentMonth, 1); // First day of the current month
	}

	//set max date - 3 months ahead
	const threeMonthsAhead = new Date(today);
	threeMonthsAhead.setMonth(today.getMonth() + 3);
	threeMonthsAhead.setDate(0); // Last day of the third month

	$(".arrange-collection .calendar").flatpickr({
		inline: true,
		minDate: minDate,
		//maxDate: new Date(currentYear + 1, 11, 31),
		maxDate: threeMonthsAhead,
		disable: [
			function (date) {
				const isBeforeToday = date < today;
				const isWeekend = date.getDay() === 0 || date.getDay() === 6;

				// Always disable weekends
				if (isWeekend) {
					return true;
				}

				// Handle December 2024 dates when navigating back
				if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth()) {
					// Disable only past dates, allow future ones in the current month
					return isBeforeToday;
				}

				// For all other cases, disable past dates
				return isBeforeToday;
			},
		],
		dateFormat: "d/m/Y", // Set the format for the flatpickr input
		enableTime: false,
		minTime: "09:00",
		maxTime: "17:00",
		time_24hr: true,
		onChange: function (selectedDates, dateStr, instance) {
			// Update the value of the target text fields
			const formattedDate = instance.formatDate(selectedDates[0], "d/m/Y");
			//const formattedTime = instance.formatDate(selectedDates[0], "H:i");
			document.getElementById("collection_date").value = formattedDate;
			//document.getElementById("collection_time").value = formattedTime;
		},
		onValueUpdate: function (selectedDates, dateStr, instance) {
			// Update the value of the time field
			const formattedTime = instance.formatDate(selectedDates[0], "H:i");
			//document.getElementById("collection_time").value = formattedTime;
		},
		onYearChange: function () {
			const selectedYear = this.currentYear;
			// Jump to January when toggling the year
			this.jumpToDate(new Date(selectedYear, 0, 1));

			// Recalculate and refresh the current month
			if (selectedYear === today.getFullYear() && today.getMonth() === 11) {
				this.jumpToDate(new Date(today.getFullYear(), 11, today.getDate()));
			}
		},
	});

	/*
===========================
DISABLE COMPANY INPUT
===========================
*/

	var input = $(".my-profile .gform_wrapper .company #input_6_6");
	if (input.val()) {
		//input.prop("disabled", true);
		input.addClass("disabled-input");
	}

	/*
  ====================================
  SELECT ALL CHECKBOXES - my instruments
  ====================================
  */

	var allChecked = false;
	$(".select-instruments li.select-all a").on("click", function (e) {
		e.preventDefault();
		allChecked = !allChecked;
		$(".instruments .row input.select-instrument").each(function () {
			$(this).prop("checked", allChecked);
		});
	});

	/*
=============================
SELECT SERVICE LEVEL
=============================
*/

	$(".service-items .service-item .item-heading").on("click", function (e) {
		var $checkbox = $(this).prev(".select-item").find("label input.select-service");
		$checkbox.prop("checked", !$checkbox.prop("checked"));
	});

	/*
========================================
SELECT SERVICE LEVELS TOTAL PRICE
========================================
*/

	function totalServicePrice() {
		var totalPrice = 0;
		// Loop through each product element and sum the prices
		$("#book-service-modal .instrument-items .instrument-item").each(function () {
			var price = parseFloat($(this).find(".service-item").data("price"));
			totalPrice += price;
			console.log(price);
		});
		// Update the total price in the div
		$("#book-service-modal .basket-total .total").text("£" + totalPrice.toFixed(2));
	}

	/*
==================================================
VALIDATE SINGLE MY INSTRUMENTS UPLOAD CERTIFICATE
==================================================
*/

	$("#upload-certificate").on("submit", function (e) {
		// Check if the file input has a value
		if (!$('input[name="acf[field_6671ae9eff239]"]').val()) {
			e.preventDefault(); // Prevent form submission
			// Display an error message near the submit button or file field
			if (!$("#upload-certificate .error-message").length) {
				$("#upload-certificate").append('<div class="error-message" style="color: red; margin-top: 10px;">Please upload a file before submitting.</div>');
			}
		}
	});

	$(".upload-certificate-section .link-bar a.toggle").on("click", function (e) {
		e.preventDefault();
		$(".upload-certificate-section .upload-certificate").slideToggle(600);
	});

	//toggle the link bar
	var link = $("#upload-certificate .file-info a");
	if (link.length) {
		// Check if the element exists
		var href = link.attr("href");
		if (href) {
			link.addClass("has-href");
			$(".upload-certificate-section .upload-certificate").slideDown();
		} else {
			link.removeClass("has-href");
			$(".upload-certificate-section .upload-certificate").slideUp();
		}
	}

	/*
=======================================
PENDING COMPANIES COUNT
=======================================
*/

	function get_pending_count() {
		var pending_companies = $("#pending-count").val();
		$(".pending-accordion .accordion-item .toggle-header .pending-count").html("(" + pending_companies + ")");

		if (pending_companies > 0) {
			$(".pending-accordion .accordion-item").addClass("active");
			$(".pending-accordion .accordion-item .toggle-content").slideToggle("fast");
		}
	}
	get_pending_count();

/*
=======================================
INVITE USER
=======================================
*/

	const $iuCompanyField = $('#gform_5 #input_5_4');

	function updateFieldStyle() {
		if ($iuCompanyField.length && $iuCompanyField.val().trim() !== '') {
			$iuCompanyField.addClass('has-value');
		} else {
			$iuCompanyField.removeClass('has-value');
		}
	}

	updateFieldStyle();
	$iuCompanyField.on('input', updateFieldStyle);


	/*
=======================================
OPEN INSTRUMENT CERTIFICATE IN MODAL
=======================================
*/

	pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";

	// Function to handle the certificate view logic
	function openCertificate(e) {
		e.preventDefault();
		var dataInstrumentID = $(this).data("instrument");
		var dataCertUrl = $(this).data("cert");

		// Ensure the URL exists
		if (dataCertUrl) {
			$("#instrument-certificate-modal .buttons .button.print, #instrument-certificate-modal .buttons .button.download").attr("href", dataCertUrl);

			var charLimit = 230;

			// Asynchronous download of PDF
			pdfjsLib.getDocument(dataCertUrl).promise.then(function (pdf) {
				// Fetch the first page
				pdf.getPage(1).then(function (page) {
					// Define A4 aspect ratio
					var a4AspectRatio = 1.414; // Height / Width for A4

					// Get image
					var viewport = page.getViewport({scale: 1.5});
					var pdfWidth = viewport.width;
					var pdfHeight = viewport.height;

					// Calculate the A4 dimensions
					var a4Width = pdfWidth;
					var a4Height = a4Width * a4AspectRatio;

					if (a4Height > pdfHeight) {
						a4Height = pdfHeight;
						a4Width = a4Height / a4AspectRatio;
					}

					// Prepare temporary canvas for rendering the full PDF page
					var tempCanvas = document.createElement("canvas");
					var tempContext = tempCanvas.getContext("2d");
					tempCanvas.width = pdfWidth;
					tempCanvas.height = pdfHeight;

					// Render PDF page into temporary canvas context
					var renderContext = {
						canvasContext: tempContext,
						viewport: viewport,
					};
					page.render(renderContext).promise.then(function () {
						// Prepare final canvas using A4 dimensions
						var $canvas = $("#pdf-canvas");
						var context = $canvas[0].getContext("2d");
						$canvas[0].width = a4Width;
						$canvas[0].height = a4Height;

						// Crop and draw the required portion to the final canvas
						context.drawImage(tempCanvas, 0, 0, a4Width, a4Height, 0, 0, a4Width, a4Height);
					});

					// Extract text from the first page
					page.getTextContent().then(function (textContent) {
						var textItems = textContent.items;
						var finalString = "";
						var charCount = 0;

						for (var i = 0; i < textItems.length; i++) {
							var item = textItems[i];
							var itemStr = item.str;

							// Check if adding this item exceeds the char limit
							if (charCount + itemStr.length > charLimit) {
								// Truncate the string to fit the limit
								finalString += itemStr.substring(0, charLimit - charCount);
								break;
							} else {
								finalString += itemStr + " ";
								charCount += itemStr.length;
							}
						}

						// Display text content in the modal div
						$("#pdf-text").text(finalString.trim() + "...");

						// Open FancyBox modal
						$.fancybox.open({
							src: "#instrument-certificate-modal",
							type: "inline",
							opts: {},
						});
					});
				});
			});
		} else {
			alert("No certificate available.");
		}
	}

	// Reattach event handlers for dynamically loaded elements
	function attachViewCertificateHandler() {
		$("a.view-certificate").each(function () {
			// Unbind any previously attached click event to prevent duplicate bindings
			$(this).off("click", openCertificate);

			// Attach the click event
			$(this).on("click", openCertificate);
		});
	}

	// Initial attachment for elements present on page load
	attachViewCertificateHandler();

	/*
==============================================================
CONFIRM PROMOTE USER TO MANAGER (CLIENT USER TO CLIENT ADMIN)
==============================================================
*/

	$(".current-users .user").each(function () {
		$(this)
			.find("a.promote")
			.on("click", function (e) {
				e.preventDefault();

				var userid = $(this).data("user-id");
				var userrole = $(this).data("user-role");

				//append clicked user id to hidden field
				$("#promote-user-modal #promotion-userid").val(userid);
				$("#promote-user-modal #promotion-userrole").val(userrole);

				if (userrole == "customer_user") {
					$.fancybox.open({
						src: "#promote-user-modal",
						type: "inline",
						opts: {},
					});
				} else {
					alert("This user is already a manager.");
				}
			});
	});

	//run ajax to switch 'customer_user' to a 'customer_manager'
	$("#promote-user-modal #confirm-promotion").on("click", function (e) {
		var userid = $("#promote-user-modal #promotion-userid").val();
		var userrole = $("#promote-user-modal #promotion-userrole").val();

		//promote user to manager ajax
		if (userid.length && userrole == "customer_user") {
			$.ajax({
				type: "POST",
				url: "/wp-admin/admin-ajax.php",
				data: {
					action: "my_change_user_role",
					user_id: userid,
					user_role: userrole,
				},
				success: function (response) {
					if (response.success) {
						alert(response.data.message);
						$.fancybox.close();
					} else {
						alert(response.data.message);
					}
				},
				error: function error() {
					alert("An error occurred.");
				},
			});
		} else {
			alert("Please select a 'customer_user'.");
		}
	});

	//close the modal
	$("#promote-user-modal a.cancel").on("click", function () {
		$.fancybox.close();
	});

	/*
==============================================================
GET INSTRUMENT & SEVICE PRODUCT IDS FROM SELECTED INSTRUMENTS
==============================================================
*/

	function get_instrument_and_service_data() {
		var instrumentServicePairs = [];

		// Loop through each div with the class 'instrument-item'
		$("#book-service-modal .instrument-items .instrument-item").each(function () {
			// Get the instrument ID
			var instrumentId = $(this).data("instrument-id");

			// Get the service-item within the instrument-item
			var serviceId = $(this).find(".service-item").data("product-id");

			// Create an object for the instrument-service pair
			var instrumentServicePair = {
				instrument_id: instrumentId,
				service_id: serviceId,
			};

			// Add the object to the array
			instrumentServicePairs.push(instrumentServicePair);
		});

		var instrumentServicePairsJson = JSON.stringify(instrumentServicePairs);

		$("#service-ids").val(instrumentServicePairsJson);
	}

	/*
=============================================
CHECKOUT FIELDSETS FADE INS
=============================================
*/

	//step 1
	$(".woocommerce-checkout fieldset.set-1 .next-button").on("click", function (e) {
		e.preventDefault();

		// Validate billing fields
		var valid = true;
		$("fieldset.set-1 .woocommerce-billing-fields .form-row").each(function () {
			if ($(this).hasClass("validate-required") && $(this).find("input, select").val() === "") {
				$(this).addClass("woocommerce-invalid");
				valid = false;
			} else {
				$(this).removeClass("woocommerce-invalid");
			}
		});

		if (valid) {
			$("fieldset.set-1").fadeOut(function () {
				$("fieldset.set-2").fadeIn(function () {
					// Scroll to the top of the page
					$("html, body").animate({scrollTop: 0}, "slow");
				});
			});
		} else {
			alert("Please fill in all required fields.");
		}
	});

	function updateShippingCost() {
		var methodHtml = $('input[name="shipping_method[0]"]:checked').next("label").find(".amount").html();
		var methodamount = $('input[name="shipping_method[0]"]:checked').next("label").find(".amount");

		$("tr.shipping td.selected-shipping").html(methodHtml);

		if (methodamount.length === 0 || methodamount.html().trim() === "") {
			$("tr.shipping td.selected-shipping").text("£0.00");
		}
	}

	//hide/show calendar based on shipping selection
	function toggleShippingDiv() {
		var selectedShippingMethod = $('input[name="shipping_method[0]"]:checked').val(); // Get the selected shipping method
		var collectionDateField = $('input[name="collection_date"]');
		var collectionDateParent = $('input[name="collection_date"]').closest(".form-row");
		var confirmButton = $(".arrange-collection a.confirm-date");

		//update the shipping in the order review
		updateShippingCost();

		// Check if the selected method is flat_rate (this can be different based on your setup)
		if (selectedShippingMethod && selectedShippingMethod.includes("flat_rate:6")) {
			// Show the div if flat_rate is selected
			$(".arrange-collection .calendar-wrap").slideDown();
			confirmButton.removeClass("continue-order");
			confirmButton.text("Confirm date");
			collectionDateParent.addClass("validate-required");
			$(".woocommerce-checkout form.checkout fieldset.set-3").hide(); //hide the next stage until the date is confirmed
			$("#pickup-availability-success").text(""); //remove success message
			$(".flatpickr-calendar .flatpickr-day").removeClass("selected"); //reset active calendar class
		} else {
			// Hide the div if any other shipping method is selected
			$(".arrange-collection .calendar-wrap").slideUp();
			confirmButton.addClass("continue-order");
			confirmButton.text("Continue order");
			collectionDateParent.removeClass("validate-required");
			collectionDateField.val("");
		}
	}

	$(document.body).on("updated_shipping_method", function () {
		toggleShippingDiv();
	});

	// Run on page load if inputs are already initialized
	if ($('input[name="shipping_method[0]"]:checked').length > 0) {
		$(document.body).trigger("updated_shipping_method");
		toggleShippingDiv();
	}

	// Run the function when the shipping method changes
	$('#shipping_method input[name="shipping_method[0]"]').on("change", function () {
		toggleShippingDiv();
	});

	//step 2
	$(".woocommerce-checkout fieldset.set-2 .next-button").on("click", function (e) {
		e.preventDefault();

		//update the shipping in the order review
		updateShippingCost();

		//clear error/success messages
		$("#pickup-availability-success").text("");
		$("#pickup-availability-error").text("");

		var dateSelected = $("#collection_date").val();
		//var timeSelected = $("#collection_time").val();
		//var timeSelected = "0900";
		var totalWeight = $("#total_instrument_weight").val();
		var countryCode = "GB";
		var addressData = {};
		const prefix = $("#ship-to-different-address-checkbox").is(":checked") ? "shipping" : "billing";

		//check if ship address is different to billing
		addressData = {
			firstname: $(`#${prefix}_first_name`).val(),
			lastname: $(`#${prefix}_last_name`).val(),
			addressLine1: $(`#${prefix}_address_1`).val(),
			city: $(`#${prefix}_city`).val(),
			county: $(`#${prefix}_state`).val(),
			postcode: $(`#${prefix}_postcode`).val(),
			phoneNo: $(`#${prefix}_phone`).val(),
			myCompany: $(`#${prefix}_company`).val(),
			countryCode: countryCode,
		};

		//if local dropoff is selected we can skip the calendar and go straight to step 3
		if ($(this).hasClass("continue-order")) {
			//fade in order confirmation
			$(".woocommerce-checkout fieldset.set-3").fadeIn(function () {
				$("html,body").animate({scrollTop: $("fieldset#set-3").offset().top - 130}, "slow");
			});
		} else {
			// Only proceed if both fields have values
			if (dateSelected) {
				// Make an AJAX request to validate the pickup availability
				$.ajax({
					url: "/wp-admin/admin-ajax.php",
					type: "POST",
					dataType: "json",
					data: {
						action: "validate_pickup_availability",
						pickup_data: {
							pickup_date: dateSelected,
							//pickup_time: timeSelected,
							address: addressData,
							total_weight: totalWeight,
						},
					},
					beforeSend: function () {
						$('<div class="loading-spinner"></div>').appendTo("fieldset.set-2 .fieldset-link");
					},
					success: function (response) {
						if (response.success) {
							//console.log(response);
							//console.log("Debug data:", response.data.debug);
							$("fieldset.set-2 .fieldset-link .loading-spinner").fadeOut(500);
							$("#pickup-availability-error").text(""); // Clear any previous error messages
							$("#pickup-availability-success").text("Pickup date available."); // Show a success message

							//fade in order confirmation
							$(".woocommerce-checkout fieldset.set-3").fadeIn(function () {
								$("html,body").animate({scrollTop: $("fieldset#set-3").offset().top - 130}, "slow");
							});
						} else {
							//console.log(response);
							//console.log("Debug data:", response.data.debug);
							//console.log("Error message:", response.data.message);
							$("fieldset.set-2 .fieldset-link .loading-spinner").fadeOut(500);
							$("#pickup-availability-error").text(response.data.message); // Display the error message
							$("#pickup-availability-success").text(""); // Clear any previous success messages
						}
					},
					error: function () {
						$("fieldset.set-2 .fieldset-link .loading-spinner").fadeOut(500);
						// Handle any errors during the AJAX request
						$("#pickup-availability-error").text("An error occurred while validating the pickup date and time. Please try again.");
						$("#pickup-availability-success").text(""); // Clear any previous success messages
						console.error("AJAX Error:", status, error);
					},
				});
			} else {
				alert("Please select a collection date");
			}
		}
	});

	/*
===================================
ORDER RECEIVED H1
===================================
*/

	function updateHeadingText() {
		if ($("body").hasClass("woocommerce-order-received")) {
			$("h1.entry-title").text("Order received");
		}
	}

	// Observe mutations on the body element
	const observer = new MutationObserver(function (mutationsList) {
		for (let mutation of mutationsList) {
			if (mutation.type === "attributes" && mutation.attributeName === "class") {
				updateHeadingText();
			}
		}
	});

	// Observe the body element for attribute changes
	observer.observe(document.body, {attributes: true});

	// Initial check
	updateHeadingText();

	$(document).on("change", '.gform_wrapper input[type="file"]', function () {
		var fileInput = $(this);
		var progressBar = fileInput.closest(".ginput_container_fileupload").find(".gform_progressbar");

		// Force show the progress bar when a file is selected
		if (progressBar.length) {
			progressBar.show();
		}
	});

	/*
  ==============================
  TOGGLE ORDER STATUS SELECT
  ==============================
  */

	function toggleStatusSelect() {
		if ($(".order-progress #delivered-to-testo").hasClass("active")) {
			$("#staff-update-order .acf-field-66d189a0c4392").show();
		} else {
			$("#staff-update-order .acf-field-66d189a0c4392").hide();
		}
	}
	//toggleStatusSelect();

	//disable add rows for the update order
	var itemCount = $(".live-status .order-items .item").length;
	// Get the value from the data attribute on the other div
	var maxItems = $("#staff-update-order").data("order-items");

	// Compare the item count with the maxItems value
	if (itemCount >= maxItems) {
		// Disable the button if the condition is met
		$("#staff-update-order .acf-repeater-add-row").prop("disabled", true);
		$("#staff-update-order .acf-repeater-add-row").addClass("disabled");
	}

	/*
==================================
woocommerce select-wrap
==================================
*/

	$(".woocommerce-additional-fields .boxes .woocommerce-input-wrapper").addClass("select-wrap");

	/*
==============================
PAYMENT OPTIONS PO FIELD
==============================
*/

	function togglePurchaseOrderUpload() {
		if ($('input[name="payment_method"]:checked').val() === "woocommerce_gateway_purchase_order") {
			$("#purchase_order_upload_field").show();
			$("#purchase_order_file").prop("required", true);
		} else {
			$("#purchase_order_upload_field").hide();
			$("#purchase_order_file").prop("required", false);
		}
	}

	// Run on initial load
	togglePurchaseOrderUpload();

	// Run on payment method change
	$(document).on("change", 'input[name="payment_method"]', function () {
		togglePurchaseOrderUpload();
	});

	$("#purchase_order_file").on("change", function () {
		var fileName = $(this).val().split("\\").pop();
		if (fileName) {
			$("#file-name").text(fileName);
		} else {
			$("#file-name").text("No file chosen");
			$("#po_field").val("");
		}
	});

	//hide po error message on cart page
	if ($("ul.woocommerce-error li").text().trim() === "File upload failed. Please try again.") {
		// Hide the <ul> if the condition is true
		$(".woocommerce-cart ul.woocommerce-error").hide();
	}

	//UPDATE HIDDEN DATE FIELD
	function updateHiddenDateField(formId, dayId, monthId, yearId, hiddenFieldId) {
		let day = $(`select#${dayId}`).val() || "01";
		let month = $(`select#${monthId}`).val();
		let year = $(`select#${yearId}`).val();

		if (day && month && year) {
			// Format date as dd/mm/yyyy
			let formattedDate = ("0" + day).slice(-2) + "/" + ("0" + month).slice(-2) + "/" + year;

			// Update the corresponding hidden field
			$(`input#${hiddenFieldId}`).val(formattedDate);
		}
	}

	function initializeDateFieldUpdates(formId, dayId, monthId, yearId, hiddenFieldId) {
		// Attach event listeners to the dropdowns
		$(`select#${dayId}, select#${monthId}, select#${yearId}`).on("change", function () {
			updateHiddenDateField(formId, dayId, monthId, yearId, hiddenFieldId);
		});

		// Run the function on page load in case values are pre-selected
		updateHiddenDateField(formId, dayId, monthId, yearId, hiddenFieldId);
	}

	// Initialize for Add Instrument Form
	initializeDateFieldUpdates("7", "input_7_9_2", "input_7_9_1", "input_7_9_3", "input_7_11");

	// Initialize for Registration Form
	initializeDateFieldUpdates("3", "input_3_21_2", "input_3_21_1", "input_3_21_3", "input_3_23");

	/*
  =================================
  AJAX
  =================================
  */

	//ADD SELECTED IDS TO BOOK SERVICE MODAL
	$(".instruments .select-instruments ul li.book-service a, .instruments .instrument .dash-meta .col a.book-service, .single-my-instruments .instrument-content a.book-service, #warranty-modal a.book-service").on("click", function (e) {
		e.preventDefault();

		var instrumentIds = [];
		var userId = $("#current-user-id").val();

		//get link targets
		var bookServiceMenuLink = $(e.target).is(".instruments .select-instruments ul li.book-service a");
		var bookServiceInstrumentLink = $(e.target).is(".instruments .instrument .dash-meta .col a.book-service");
		var bookServiceSingleInstrumentLink = $(e.target).is(".single-my-instruments .instrument-content a.book-service");
		var bookServiceSingleModal = $(e.target).is("#warranty-modal a.book-service");
		var bookInterimInspection = $(e.target).is("#warranty-modal a.book-interim-inspection");

		//if the my instruments menu link was clicked loop through the checked instruments otherwise get the data instrument id from the button
		if (bookServiceMenuLink) {
			$(".instruments .row input.select-instrument:checked").each(function () {
				instrumentIds.push($(this).val());
			});
		} else {
			var dataInstrumentID = $(this).data("instrument");
			instrumentIds.length = 0;

			if (instrumentIds.length === 0) {
				instrumentIds.push(dataInstrumentID);
			}
		}

		if (instrumentIds.length > 0) {
			$("#selected-instrument-ids").val(instrumentIds.join(","));

			//append items to modal
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: {
					action: "get_selected_instruments",
					instrument_ids: instrumentIds,
					user_id: userId,
					book_interim_inspection: bookInterimInspection,
				},
				success: function (response) {
					// Append the response to the modal content
					$("#book-service-modal .instrument-items").html(response);

					//update the total price
					totalServicePrice();

					//add the service ids to a hidden field
					//get_service_ids_from_instruments();
					get_instrument_and_service_data();

					// Open the modal using Fancybox after the content is appended
					$.fancybox.open({
						src: "#book-service-modal",
						type: "inline",
						opts: {
							afterClose: function () {
								// Clear the selected instrument IDs
								instrumentIds = [];
							},
						},
					});
				},
				error: function (jqXHR) {
					// Handle error response
					if (jqXHR.status === 400) {
						// Check for the 400 status code
						const error = JSON.parse(jqXHR.responseText);
						alert(error.error); // Display the error message
					} else {
						alert("An unexpected error occurred. Please try again or get in touch.");
					}
				},
			});
		} else {
			alert("No instruments selected.");
		}
	});

	//REMOVE INSTRUMENTS FUNCTION (SET TO DRAFT)
	function removeInstruments(postIds, userId) {
		if (postIds.length > 0) {
			$.ajax({
				url: myAjax.ajaxurl,
				type: "POST",
				data: {
					action: "remove_my_instruments",
					nonce: myAjax.nonce,
					post_ids: postIds,
					user_id: userId,
				},
				success: function success(response) {
					alert("The selected instrument/s have been removed.");
					window.location.href = "/dashboard/my-instruments"; // Redirect to the target page
				},
				error: function error() {
					alert("An error occurred.");
				},
			});
		} else {
			alert("No posts selected.");
		}
	}

	//REMOVE INSTRUMENTS FUNCTION (SET TO DRAFT)
	function removeCoreInstruments(postIds) {
		if (postIds.length > 0) {
			$.ajax({
				url: cdAjax.ajaxurl,
				type: "POST",
				data: {
					action: "remove_core_instruments",
					nonce: cdAjax.nonce,
					post_ids: postIds,
				},
				success: function success(response) {
					alert("The selected core instrument/s have been removed.");
					window.location.href = "/dashboard/manage-instruments"; // Redirect to the target page
				},
				error: function error() {
					alert("An error occurred.");
				},
			});
		} else {
			alert("No posts selected.");
		}
	}

	//ADD SELECTED IDS TO REMOVE ITEMS (set draft)
	$(".instruments .select-instruments ul li.remove-instruments a").on("click", function (e) {
		e.preventDefault();
		var postIds = [];
		$(".instruments .row input.select-instrument:checked").each(function () {
			postIds.push($(this).val());
		});
		$("#selected-instrument-ids").val(postIds.join(","));
		if ($("#selected-instrument-ids").val() !== "") {
			$.fancybox.open({
				src: "#confirm-remove-modal",
				type: "inline",
			});
		} else {
			alert("No instruments selected.");
		}
	});

	//BULK SELECT AND ADD MY INSTRUMENTS ITEMS TO ARRAY
	$("a#remove-my-instruments").on("click", function (e) {
		e.preventDefault();
		var selectedInstruments = $("#selected-instrument-ids").val();
		var userId = $("#current-user-id").val();
		if (selectedInstruments !== "") {
			var postIds = selectedInstruments.split(",");
			removeInstruments(postIds, userId);
		}
	});

	//BULK SELECT AND ADD CORE INSTRUMENT ITEMS TO THE ARRAY
	$("a#remove-core-instruments").on("click", function (e) {
		e.preventDefault();
		var selectedInstruments = $("#selected-instrument-ids").val();
		if (selectedInstruments !== "") {
			var postIds = selectedInstruments.split(",");
			removeCoreInstruments(postIds);
		}
	});

	//SINGLE INSTRUMENT REMOVAL
	$("a#remove-single-instrument").on("click", function (e) {
		e.preventDefault();
		var postIds = [];
		postIds.push($(this).data("instrument"));
		var userId = $("#current-user-id").val();
		removeInstruments(postIds, userId);
	});

	/*
==================================
ADD SERVICES TO CART
==================================
*/

	function setCookie(name, value) {
		document.cookie = name + "=" + (value || "") + "; path=/";
	}

	$("#book-service-modal a#add-to-basket").on("click", function (e) {
		e.preventDefault();

		var serviceIds = $("#service-ids").val();
		var userId = $("#current-user-id").val();
		var staff = false;

		if ($("body").hasClass("role-staff")) {
			var staff = true;
			//store the user_id in a cookie to use in cart
			setCookie("user_id_set_by_staff", userId);
		}

		if (serviceIds.length > 0) {
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: {
					action: "add_services_to_basket",
					instrument_service_pairs: serviceIds,
					user_id: userId,
					staff: staff,
				},
				success: function (response) {
					console.log(response);
					if (response.success) {
						// Open the modal using Fancybox after the content is appended
						$.fancybox.open({
							src: "#added-to-basket-modal",
							type: "inline",
							opts: {
								afterClose: function () {
									// Clear the selected instrument IDs
								},
							},
						});
					} else {
						alert("Failed to add instruments to the cart. Please try again.");
					}
				},
				error: function error() {
					alert("An error occurred.");
				},
			});
		}
	});

	/*
==========================
SEARCH COMPANIES
==========================
*/

	$("form#search-companies").on("submit", function (e) {
		e.preventDefault();

		var search_term = $("#search-companies input[type='text'").val();

		//Anchor down to knowledge hub results
		var anchor_id = "#manage-users";
		$("html, body").animate(
			{
				scrollTop: $(anchor_id).offset().top - 250,
			},
			800
		);

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "search_companies",
				search_term: search_term,
			},
			beforeSend: function () {
				$("#current-companies .ajax-container").fadeTo(600, 0, function () {
					$("#current-companies .ajax-container").html('<div class="loading-spinner"></div>');
				});
				$("#current-companies .ajax-container").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$("#current-companies .ajax-container")
					.delay(800)
					.fadeOut(700, function () {
						$("#current-companies .ajax-container .loading-spinner").remove();
						$("#current-companies .ajax-container").append(data);
						$("#current-companies .ajax-container").fadeTo(400, 1);
					});
			},
		});
	});

	/*
==================================
CURRENT / PENDING USERS TOGGLE 
==================================
*/

	$('.user-type-toggle input[name="user-type"]').on("change", function (e) {
		e.preventDefault();

		var user_type = $(this).val();
		var company_name = new URL(location.href).searchParams.get("company"); //get company name from query string

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_company_users",
				company_name: company_name,
				user_type: user_type,
			},
			beforeSend: function () {
				$("#current-users .ajax-container").fadeTo(300, 0, function () {
					$("#current-users .ajax-container").html('<div class="loading-spinner"></div>');
				});
				$("#current-users .ajax-container").delay(200).fadeTo(300, 1);
			},
			success: function (data) {
				$("#current-users .ajax-container")
					.delay(400)
					.fadeOut(400, function () {
						$("#current-users .ajax-container .loading-spinner").remove();
						$("#current-users .ajax-container").append(data);
						$("#current-users .ajax-container").fadeTo(300, 1);
					});
			},
		});
	});

	/*
==========================
SEARCH CORE INSTRUMENTS
==========================
*/

	$("form#search-core-instruments").on("submit", function (e) {
		e.preventDefault();

		var search_term = $("#search-core-instruments input[type='text']").val();

		//Anchor down to knowledge hub results
		var anchor_id = "#core-instruments";
		$("html, body").animate(
			{
				scrollTop: $(anchor_id).offset().top - 250,
			},
			800
		);

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "search_core_instruments",
				search_term: search_term,
			},
			beforeSend: function () {
				$("#core-instruments .ajax-container").fadeTo(600, 0, function () {
					$("#core-instruments .ajax-container").html('<div class="loading-spinner"></div>');
				});
				$("#core-instruments .ajax-container").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$("#core-instruments .ajax-container")
					.delay(800)
					.fadeOut(700, function () {
						$("#core-instruments .ajax-container .loading-spinner").remove();
						$("#core-instruments .ajax-container").append(data);
						$("#core-instruments .ajax-container").fadeTo(400, 1);
					});
			},
		});
	});

	/*
=========================
LOAD MORE ORDERS (STAFF)
=========================
*/


	$(".manage-orders .orders .ajax-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		const $container = $(".manage-orders .orders .ajax-container");
		const loaded = parseInt($container.find("input.order-count").val(), 10) || 0;
		const totalOrderCount = parseInt($container.find("input.total-order-count").val(), 10) || 0;
		const currentPage = parseInt($container.find("input.current-page").val(), 10) || 1;

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_orders",
				already_loaded: loaded,
				total_order_count: totalOrderCount,
				paged: currentPage + 1 // incrementing page manually
			},
			beforeSend: function () {
				$container.find(".load-more-posts").fadeTo(300, 0, function () {
					$(this).html('<div class="load">Loading...</div>');
				}).delay(100).fadeTo(200, 1);
			},
			success: function (data) {
				$container.find(".load-more-posts").fadeOut(300, function () {
					$(this).remove();
					$container.append(data);
				});
			},
			error: function (xhr, status, error) {
				console.error("AJAX Error:", error);
			}
		});
	});

	/*
==================================
LOAD MORE ORDER HISTORY (CLIENT)
==================================
*/

	$(".order-history .orders .ajax-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.order-count").val();
		var user_id = $("input.user-id").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_order_history",
				already_loaded: loaded,
				user_id: user_id,
			},
			beforeSend: function () {
				$(".order-history .orders .ajax-container .load-more-posts").fadeTo(600, 0, function () {
					$(".order-history .orders .ajax-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".order-history .orders .ajax-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".order-history .orders .ajax-container .load-more-posts")
					.delay(800)
					.fadeOut(600, function () {
						$(".order-history .orders .ajax-container .load-more-posts").remove();
						$(".order-history .orders .ajax-container").append(data);
					});
				attachViewCertificateHandler();
			},
		});
	});

	/*
==================================
LOAD MORE CORE INSTRUMENTS (STAFF)
==================================
*/

	$(".core-instruments .ajax-container").on("click", ".load-more", function (e) {
		e.preventDefault();

		var loaded = $("input.instrument-count").val();
		var user_id = $("input.user-id").val();

		$.ajax({
			url: "/wp-admin/admin-ajax.php",
			type: "POST",
			data: {
				action: "load_more_core_instruments",
				already_loaded: loaded,
				user_id: user_id,
			},
			beforeSend: function () {
				$(".core-instruments .ajax-container .load-more-posts").fadeTo(600, 0, function () {
					$(".core-instruments .ajax-container .load-more-posts").html('<div class="load"></div>');
				});
				$(".core-instruments .ajax-container .load-more-posts").delay(300).fadeTo(400, 1);
			},
			success: function (data) {
				$(".core-instruments .ajax-container .load-more-posts")
					.delay(800)
					.fadeOut(600, function () {
						$(".core-instruments .ajax-container .load-more-posts").remove();
						$(".core-instruments .ajax-container").append(data);
					});
				attachViewCertificateHandler();
			},
		});
	});

	/*
==================================
CHECK RETURN SHIPMENT DATE & Time
==================================
*/

	$("a#check-return-shipment-date").on("click", function (e) {
		e.preventDefault();

		//clear error/success messages
		$("#create-return-shipment #pickup-availability-success").text("");
		$("#create-return-shipment #pickup-availability-error").text("");

		var urlParams = new URLSearchParams(window.location.search);
		var orderID = urlParams.get("order");
		var returnDate = $("#create-return-shipment #collection_date").val();
		//var returnTime = $("#create-return-shipment #collection_time").val();
		var totalWeight = $("#create-return-shipment #total_instrument_weight").val();
		var pickupAddressJson = $("#create-return-shipment #shipping_address").val();
		var storeAddressJson = $("#create-return-shipment #store_address").val();
		// Parse the JSON string back into an object
		var pickupAddressData = JSON.parse(pickupAddressJson);
		var storeAddressData = JSON.parse(storeAddressJson);

		if (returnDate && returnTime && orderID) {
			// Make an AJAX request to validate the pickup availability
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				dataType: "json",
				data: {
					action: "validate_pickup_availability",
					pickup_data: {
						pickup_date: returnDate,
						//pickup_time: returnTime,
						address: storeAddressData,
						total_weight: totalWeight,
					},
					order_id: orderID,
				},
				success: function (response) {
					if (response.success) {
						//console.log(response);
						//console.log("Debug data:", response.data.debug);
						$("#pickup-availability-error").text(""); // Clear any previous error messages
						$("#pickup-availability-success").text("Pickup date and time available."); // Show a success message
						$("#create-return-shipment-btn").fadeIn(300);
					} else {
						//console.log(response);
						//console.log("Debug data:", response.data.debug);
						//console.log("Error message:", response.data.message);
						$("#pickup-availability-error").text(response.data.message); // Display the error message
						$("#pickup-availability-success").text(""); // Clear any previous success messages
					}
				},
				error: function (response) {
					$("#pickup-availability-error").append(response);
					// Handle any errors during the AJAX request
					$("#pickup-availability-error").text("An error occurred while validating the pickup date and time. Please try again.");
					$("#pickup-availability-success").text(""); // Clear any previous success messages
					console.error("AJAX Error:", status, error);
				},
			});
		} else {
			alert("Please select a collection date & time");
		}
	});

	/*
==================================
CREATE RETURN SHIPMENT
==================================
*/
	$("a#create-return-shipment-btn").on("click", function (e) {
		e.preventDefault();

		var urlParams = new URLSearchParams(window.location.search);
		var orderID = urlParams.get("order");
		var returnDate = $("#create-return-shipment #collection_date").val();
		var totalWeight = $("#create-return-shipment #total_instrument_weight").val();
		var shipmentAddressJson = $("#create-return-shipment #shipping_address").val();
		var storeAddressJson = $("#create-return-shipment #store_address").val();
		// Parse the JSON string back into an object
		var shipmentAddressData = JSON.parse(shipmentAddressJson);
		var storeAddressData = JSON.parse(storeAddressJson);

		if (returnDate && returnTime && orderID) {
			// Make an AJAX request to validate the pickup availability
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				dataType: "json",
				data: {
					action: "create_ups_return_shipment",
					pickup_data: {
						pickup_date: returnDate,
						total_weight: totalWeight,
						address: storeAddressData,
						shipment_address: shipmentAddressData,
					},
					order_id: orderID,
				},
				success: function (response) {
					if (response.success) {
						// Handle success
						console.log("Success: ", response.data.message);
						console.log("Tracking Code: ", response.data.tracking_code);
						console.log("Reference Number: ", response.data.reference_number);

						// Optionally display messages to the user
						alert("Return shipment successfully created. Tracking Code: " + response.data.tracking_code);
					} else {
						// Handle error
						console.log("Error: ", response.data.message);

						// Optionally display error messages to the user
						alert("Error: " + response.data.message);
					}
				},
				error: function (xhr, status, error) {
					// Handle AJAX errors
					console.log("AJAX Error: ", status, error);

					// Optionally display an error message to the user
					alert("An error occurred while processing your request. Please try again.");
				},
			});
		} else {
			alert("Please select a collection date & time");
			alert("AJAX Error: " + error);
		}
	});

	/*
==============================
CHECKOUT FORM SUBMISSION
==============================
*/

	/*$("form.checkout").on("submit", function (e) {
		e.preventDefault(); // Prevent default form submission

		// Perform AJAX call
		$.ajax({
			type: "POST",
			url: "/wp-admin/admin-ajax.php",
			data: {
				action: "validate_ups_before_checkout",
			},
			success: function (response) {
				if (response.success) {
					// If success, proceed with the checkout submission
					$("form.checkout")[0].submit();
				} else {
					// If failure, alert or show an error
					alert("Checkout cannot proceed: " + response.data.message);
				}
			},
			error: function () {
				alert("AJAX error. Please try again.");
			},
		});
	});*/

	/*
==============================
VOID / CANCEL SHIPMENT
==============================
*/

	$("#cancel-shipment-modal a#cancel-shipment").on("click", function (e) {
		e.preventDefault(); // Prevent default form submission

		var tracking_number = $("#shipment-tracking-code").val();
		var shipment_id = $("#shipment-ref").val();
		var order_id = $("#order-id").val();
		var packages_tracking_array = $("#shipment-packages-tracking-numbers").val();
		var ups_pickup_confirmation_number = $("#ups-pickup-confirmation-number").val();
		var collection_date = $("#collection-date").val();

		if (tracking_number && shipment_id && order_id) {
			// Perform AJAX call
			$.ajax({
				type: "POST",
				url: "/wp-admin/admin-ajax.php",
				data: {
					action: "void_ups_shipment",
					tracking_number: tracking_number,
					shipment_id: shipment_id,
					order_id: order_id,
					packages_tracking_array: packages_tracking_array,
					ups_pickup_confirmation_number: ups_pickup_confirmation_number,
					collection_date: collection_date
				},
				success: function (response) {
					if (response.success) {
						//alert("Success:\n" + JSON.stringify(response.data, null, 2));
						let successMessage = "Success:\n";

						if (response.data.shipment && response.data.shipment.status === 'success') {
							successMessage += `\nShipment:\n- Status: ${response.data.shipment.status}\n- Message: ${response.data.shipment.message}`;
						}
						if (response.data.pickup && response.data.pickup.status === 'success') {
							successMessage += `\n\nPickup:\n- Status: ${response.data.pickup.status}\n- Message: ${response.data.pickup.message}`;
						}
						alert(successMessage);
						//alert("Success:\n" + JSON.stringify(response.data, null, 2));
						console.log("Success:", response.data);
					} else {
						let errorMessage = "One or more errors occurred:\n";
	
						if (response.data.shipment) {
							const s = response.data.shipment;
						
							if (s.status === 'error' || s.status === 'skipped') {
								errorMessage += `\nShipment Error:\n- Message: ${s.message}\n- Code: ${s.error_code}\n- Details: ${s.error_message}\n`;
							}
							else if (s.status === 'success') {
								errorMessage += `\nShipment voided successfully.`;
							}
						}
	
						if (response.data.pickup) {
							const p = response.data.pickup;
						
							if (p.status === 'error') {
								errorMessage += `\nPickup Error:\n- Message: ${p.message}\n- Code: ${p.error_code}\n- Details: ${p.error_message}\n`;
							} else if (p.status === 'success') {
								errorMessage += `\nPickup cancelled successfully.`;
							}
						}
	
						alert(errorMessage);
						console.error("Void Errors:", response.data);
						console.log("Void Errors:", response.data);
					}
	
					$.fancybox.close();
				},
				error: function () {
					alert("AJAX error. Please try again.");
					$.fancybox.close();
				},
			});
		} else {
			alert("Error: Something went wrong.");
		}
	});
}); //end document.ready
//# sourceMappingURL=scripts.js.map
